import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    padding: theme.spacing(1, 2),
    fontSize: '0.9rem',
    marginTop: '1rem',
    background: theme.palette.warning.contrastText,
    border: `1px solid ${theme.palette.orange[300]}`,
    borderLeft: `${theme.spacing(1)} solid ${theme.palette.warning.main}`,
  },
  ul: {
    marginTop: '0',
  },
  li: {
    fontWeight: 'bold',
  },
  alertIcon: {
    color: theme.palette.warning.main,
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: '0.5rem',
    '& svg path': {
      fill: theme.palette.orange[400],
    },
  },
}));

export default useStyles;
